(function() {
  const DISCOUNT_CODE = 'SERUM-REGALO';
  const GIFT_VARIANT_ID = 52046692811093;

  function giftLineIndex(items) {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === GIFT_VARIANT_ID) return i + 1;
    }
    return -1;
  }

  // Aplica el código de descuento de Shopify SIN salir del carrito.
  // El endpoint /discount/CODIGO fija el descuento en la sesión y redirige;
  // usamos fetch para no sacar al usuario de la página.
  function applyDiscountCode() {
    return fetch('/discount/' + DISCOUNT_CODE, { method: 'GET', redirect: 'follow' })
      .catch(function(){ /* silencioso */ });
  }

  function addGiftToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
    }).then(function(r){ return r.json(); });
  }

  function removeGiftFromCart(lineIndex) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });
  }

  // Cuando se detecta el código: añade el sérum (si no está) Y aplica el descuento, luego recarga.
  function activateGift() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var hasGift = giftLineIndex(cart.items) !== -1;
        // Aplica el código primero, luego añade el sérum si falta, y recarga
        applyDiscountCode().then(function(){
          if (!hasGift) {
            addGiftToCart().then(function(){ window.location.reload(); });
          } else {
            window.location.reload();
          }
        });
      });
  }

  function handleDiscountInput() {
    const input = document.querySelector('#CartDiscountcode, [data-name="discount"], input[name="discount"]');
    if (!input) return;
    input.addEventListener('change', function() {
      const code = this.value.trim().toUpperCase();
      if (code === DISCOUNT_CODE) {
        activateGift();
      } else {
        // si borran el código, quitar el sérum
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var line = giftLineIndex(cart.items);
          if (line !== -1) removeGiftFromCart(line).then(function(){ window.location.reload(); });
        });
      }
    });
  }

  // Si la URL trae el descuento aplicado (?discount=SERUM-REGALO o /discount/),
  // y el código está activo, asegura que el sérum esté en el carrito.
  function checkUrlDiscount() {
    var u = window.location.href.toUpperCase();
    if (u.indexOf('DISCOUNT=' + DISCOUNT_CODE) !== -1 || u.indexOf('/DISCOUNT/' + DISCOUNT_CODE) !== -1) {
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        if (giftLineIndex(cart.items) === -1) {
          addGiftToCart().then(function(){ window.location.reload(); });
        }
      });
    }
  }

  function init() {
    handleDiscountInput();
    checkUrlDiscount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();